export enum Roles {
  agent = 'Agent*in',
  admin = 'Admin',
  superAdmin = 'Super Admin',
}
